<template>
  <div class="zapi-stepper flex align-items-center justify-content-between border-round-3xl p-1 mx-1 bg-gray-50 border-1 surface-border">
    <button 
      class="zapi-stepper-btn border-circle flex align-items-center justify-content-center cursor-pointer transition-colors border-none bg-white shadow-1"
      @click.stop="$emit('restar')"
    >
      <i class="pi pi-minus font-bold text-xs"></i>
    </button>
    <div 
      class="font-bold text-center cursor-pointer flex-1 zapi-stepper-value text-md text-900 transition-colors"
      @click.stop="$emit('editar')"
      v-tooltip.top="'Editar número'"
    >
      {{ cantidad }}
    </div>
    <button 
      class="zapi-stepper-btn border-circle flex align-items-center justify-content-center cursor-pointer transition-colors border-none bg-white shadow-1"
      @click.stop="$emit('sumar')"
    >
      <i class="pi pi-plus font-bold text-xs"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: 'ZapiStepper',
  props: {
    cantidad: {
      type: [Number, String],
      required: true
    }
  },
  emits: ['sumar', 'restar', 'editar']
}
</script>

<style scoped>
.zapi-stepper {
  width: 8rem;
}
.zapi-stepper-btn {
  width: 2.3rem;
  height: 2.3rem;
  color: #4b5563;
  outline: none;
}
.zapi-stepper-btn:hover {
  background-color: #fce4e4 !important;
  color: #e32f3a;
}
.zapi-stepper-btn:active {
  transform: scale(0.92);
}
.zapi-stepper-value {
  user-select: none;
}
.zapi-stepper-value:hover {
  color: #e32f3a !important;
}
</style>
